import { render } from "./PublicationModal.vue?vue&type=template&id=213b41c3&scoped=true"
import script from "./PublicationModal.vue?vue&type=script&lang=js"
export * from "./PublicationModal.vue?vue&type=script&lang=js"

import "./PublicationModal.vue?vue&type=style&index=0&id=213b41c3&lang=stylus&scoped=true"
import "./PublicationModal.vue?vue&type=style&index=1&id=213b41c3&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213b41c3"]])

export default __exports__